var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"adList"},_vm._l((_vm.ads),function(data,index){return _c('RentalObjectAd',{key:data.letting.id,class:{ 'mt-4': index > 0 },attrs:{"iM":data.iM,"landlord-id":_vm.landlordId,"letting":data.letting},on:{"publish-to-finn":lettingId => _vm.$emit('publish-to-finn', lettingId)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }